export default __webpack_public_path__ + "static/media/leovac.de9d6db0.png";